export const setTypeDef = {
    Set: {
        replace: (set) => ({
            $t: 'Set',
            v: Array.from(set),
        }),
        revive: ({ v }) => new Set(v),
    },
};
export default setTypeDef;
